import { Camera24Icon } from "@kaltura/ds-react-icons";
import { Button } from "@kaltura/ds-react-components";
import { isMobileDevice, translate } from "@kaltura/mediaspace-shared-utils";
import { ButtonClickAnalyticsType } from "@kaltura/mediaspace-shared-types";
import { useButtonAnalytics } from "@kaltura/mediaspace-shared-hooks";

interface MeetingButtonProps {
    size?: "large" | "medium";
    isAdmin: boolean;
    mobileSupport: boolean;
    isAdvancedTemplateRoom: boolean;
    isNewrowSupported: boolean;
    startMeeting: () => void;
    openMeeting: () => void;
}

/**
 * kme start/join meeting button to render inside the lobby
 */
const MeetingButton = (props: MeetingButtonProps) => {
    const {
        isAdmin,
        mobileSupport,
        isNewrowSupported,
        startMeeting,
        openMeeting,
        size,
        isAdvancedTemplateRoom = false,
    } = props;

    const showMobileButton = isMobileDevice && mobileSupport && !isAdvancedTemplateRoom && isNewrowSupported;

    const getButtonText = () => {
        if (isAdvancedTemplateRoom) {
            return translate("Enter Room");
        }
        else if (showMobileButton) {
            return translate("Launch app session");
        }
        else if (isAdmin) {
            return translate("Start Meeting");
        }
        else {
            return translate("Join Meeting");
        }
    };

    const buttonText = getButtonText();

    const sendButtonAnalytics = useButtonAnalytics();

    const onButtonClick = () => {
        const action = showMobileButton ? "Launch app" : isAdmin ? "Start" : "Enter";
        sendButtonAnalytics(`Media Hero - ${action} session`, ButtonClickAnalyticsType.LAUNCH);
        isAdmin ? startMeeting() : openMeeting();
    };

    return (
        <Button
            color={"primary"}
            onClick={onButtonClick}
            startIcon={<Camera24Icon />}
            aria-label={buttonText}
            size={size}
        >
            {buttonText}
        </Button>
    );
};

export default MeetingButton;
